import React, { useState } from "react";
import EditReplaceVehicleModal from "./EditReplaceVehicleModal2";
import { useTheme } from "../hooks/useTheme";
import useGeneral from "../hooks/useGeneral";
import moment from "moment";

type VehicleReplaceListProps = {
    vehicleReplaceReport: any[];
    refreshTheSummary: (value: boolean) => void;
    reservationId: number;
    locationOptions: any[];
    checkInFiles: any[];
    vehicleReplacementCheckOutFiles: any[];
    vehicleReplacementCheckInFiles: any[];
    checkOutFiles: any[];
    formattedCreatedAt: string;
    isCompletedOrCancelled: boolean;
    refreshTheAttachement: () => void;
    setPleaseWait: (value: boolean) => void;
}

const VehicleReplaceList = ({
    vehicleReplaceReport,
    refreshTheSummary,
    reservationId,
    locationOptions,
    checkInFiles,
    checkOutFiles,
    vehicleReplacementCheckOutFiles,
    vehicleReplacementCheckInFiles,
    formattedCreatedAt,
    isCompletedOrCancelled,
    refreshTheAttachement,
    setPleaseWait
}: VehicleReplaceListProps) => {
    const { themeStyles } = useTheme();
    const { dateFormat }: any = useGeneral();
    const [editReplaceVehicleIsOpen, setEditReplaceVehicleIsOpen] = useState<boolean>(false);
    const [replacementModalData, setReplacementModalData] = useState<any>({});

    return (
        <div className="mt-2 w-full">
            <table className="min-w-full">
                <tbody className="text-left">
                    <tr className={`border-b ${themeStyles.main.borderColor}`}>
                        <th className={`w-[5%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                        <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Replaced Vehicle</th>
                        <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Replacement Vehicle</th>
                        <th className={`w-[25%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Replacement Comments</th>
                        <th className={`w-[10%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                        <th className={`w-[10%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created At</th>
                    </tr>

                    {
                        vehicleReplaceReport?.map((item: any, index: number) => {
                            return (
                                <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                                    <td className="pr-[0.25rem] py-2 w-[5%] ">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.id}</span>
                                    </td>

                                    <td className="px-[0.25rem] py-2 w-[25%]">
                                        <span
                                            className={`text-xs font-medium hover:underline text-[#0000ff] cursor-pointer`}
                                            onClick={() => {
                                                setEditReplaceVehicleIsOpen(true);
                                                setReplacementModalData(item);
                                            }}
                                        >
                                            {item?.replacedVehicle}
                                        </span>
                                    </td>

                                    <td className="px-[0.25rem] py-2 w-[25%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.replacementVehicle}</span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[25%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.replacementComments}</span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[10%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.createdBy}</span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[10%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                            {moment(new Date(item?.createdAt)).format(dateFormat + " hh:mm a")}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>

            <EditReplaceVehicleModal
                editReplaceVehicleIsOpen={editReplaceVehicleIsOpen}
                setEditReplaceVehicleIsOpen={setEditReplaceVehicleIsOpen}
                refreshTheSummary={refreshTheSummary}
                replacementModalData={replacementModalData}
                reservationId={reservationId}
                locationOptions={locationOptions}
                checkOutFiles={checkOutFiles}
                checkInFiles={checkInFiles}
                vehicleReplacementCheckOutFiles={vehicleReplacementCheckOutFiles}
                vehicleReplacementCheckInFiles={vehicleReplacementCheckInFiles}
                formattedCreatedAt={formattedCreatedAt}
                refreshTheAttachement={refreshTheAttachement}
                isCompletedOrCancelled={isCompletedOrCancelled}
                setPleaseWaitPopup={setPleaseWait}
            />
        </div>
    )
}

export default VehicleReplaceList;